import { Component } from '@angular/core';

@Component({
    selector: 'c-skip-warning',
    templateUrl: './skip-warning.component.html',
    styleUrls: ['./skip-warning.component.scss'],
    standalone: false
})
export class SkipWarningComponent {
  close: () => void;
  continue: () => void;
  contentKey: string;
}
